import { render, staticRenderFns } from "./selectTextByVoice.vue?vue&type=template&id=9148036c&scoped=true"
import script from "./selectTextByVoice.vue?vue&type=script&lang=js"
export * from "./selectTextByVoice.vue?vue&type=script&lang=js"
import style0 from "./selectTextByVoice.vue?vue&type=style&index=0&id=9148036c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9148036c",
  null
  
)

export default component.exports